import { useEffect, useRef, useState } from "react";
import { Check } from "lucide-react";
import { StepShell } from "./ui";

const STAGES = ["Checking NRI-friendly developers", "Matching your budget", "Checking possession timelines"];

export const Searching = ({ run, onDone }) => {
  const [stage, setStage] = useState(0);
  const pending = useRef(null);
  useEffect(() => {
    pending.current = pending.current || run();
    let live = true;
    const timers = [1300, 2600, 3900].map((ms, i) => setTimeout(() => setStage(i + 1), ms));
    const minWait = new Promise((r) => setTimeout(r, 4600));
    Promise.all([pending.current, minWait]).then(([result]) => live && onDone(result));
    return () => {
      live = false;
      timers.forEach(clearTimeout);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <StepShell stepKey="searching" testId="screen-searching">
      <div className="flex flex-1 flex-col justify-center pb-16">
        <div className="mb-8 flex gap-2">
          {[0, 1, 2].map((i) => (
            <span key={i} className="pulse-dot h-2.5 w-2.5 rounded-full bg-[var(--saffron)]" style={{ animationDelay: `${i * 0.18}s` }} />
          ))}
        </div>
        <h2 className="font-display text-[1.8rem] font-medium leading-tight text-[#1f2328] sm:text-4xl">
          Searching projects suitable for you that support NRIs…
        </h2>
        <ul className="mt-10 space-y-5" data-testid="searching-stages">
          {STAGES.map((s, i) => {
            const done = stage > i;
            const active = stage === i;
            return (
              <li key={s} className={`flex items-center gap-3 text-[15px] transition-opacity duration-500 ${done || active ? "opacity-100" : "opacity-35"}`}>
                <span className={`flex h-7 w-7 items-center justify-center rounded-full border-2 transition-colors ${done ? "border-[#138808] bg-[#138808] text-white" : "border-neutral-300"}`}>
                  {done ? <Check className="h-4 w-4" /> : active ? <span className="pulse-dot h-2 w-2 rounded-full bg-[var(--saffron)]" /> : null}
                </span>
                {s}
              </li>
            );
          })}
        </ul>
      </div>
    </StepShell>
  );
};
